module.exports = __webpack_public_path__ + "img/bg-top-right.2137c504.png";